import {Pipe, PipeTransform} from '@angular/core';
import {CustomFieldModel} from '@base/modules/rest/custom-field/model/custom-field.model';

@Pipe({
  name: 'fieldSettingsSearch',
})
export class FieldSettingsDialogSearchPipe implements PipeTransform {

  transform(filteredFields: CustomFieldModel[], fields: CustomFieldModel[], searchValue: string): CustomFieldModel[] {

    if (searchValue) {
      return fields
        .filter(item => item?.label
          .toLowerCase()
          .includes(searchValue.toLowerCase())
        );
    }

    return filteredFields;
  }

}
